import { isLocalServer } from "./custom_utils";

const LOCAL_URL = "http://localhost:3019/apis/v1";
const PUBLIC_URL = "https://resident.milesbreed.com/apis/v1";
export const API_URL = isLocalServer() ? LOCAL_URL : PUBLIC_URL;
export const PROFILE_IMG_BASE_URL = isLocalServer()
  ? "http://localhost:3019"
  : "https://resident.milesbreed.com";
